import { of, Subject, BehaviorSubject } from 'rxjs';
import {
  Patient,
  Hospital,
  Scale,
  Physics,
  Zoom,
  Info,
  Ring,
} from './../share/corner-info';
import { Injectable } from '@angular/core';
import { Vector3 } from 'three';

@Injectable({
  providedIn: 'root',
})
export class CornerInfoService {
  public info = new BehaviorSubject<Info>(new Ring(new Vector3(0, 0, 0), 20));
  info$ = this.info.asObservable();

  constructor() {}

  top_left_info() {
    return ['AAA', 123, new Date(Date.now()), 'F', 40, 'CT', 30, -20.3];
  }
  top_right_info() {
    return ['x HSP', 'PET-CT', 'Pi-16', 'HFS'];
  }
  bottom_left_info() {
    return [100, 10, 30, 200];
  }

  bottom_right_info() {
    return ['W 350', 'C 50', 'Zoom: 1.00'];
  }

  updateInfo(update: Info) {
    this.info.next(update);
  }
  getPatient(id: number) {
    return of(
      new Patient('AAA', 123, new Date(Date.now()), 'F', 40, 'CT', 30, -20.3),
    );
  }

  currentPatient() {
    return of(
      new Patient('AAA', 123, new Date(Date.now()), 'F', 40, 'CT', 30, -20.3),
    );
  }

  currentHospital() {
    return of(new Hospital('x HSP', 'PET-CT', 'Pi-16', 'HFS'));
  }
  currentScale() {
    return of(new Scale(10, 'R'));
  }
  currentPhysics() {
    return of(new Physics(100, 10, 30, 200));
  }
  currentZoom() {
    return of(new Zoom('W 350', 'C 50', 'Zoom: 1.00'));
  }

  ROI_info() {
    // return of({ area: 'area:100', value: 'value:100' });
    return of(['area:100', 'value:100']);
  }
}
